import React from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../common/GridLayout";

import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Pager,
    LoadPanel,
    Export,
    ColumnHeaderFilter,
    ColumnChooser,
    ColumnChooserSearch,
    HeaderFilter,
    ColumnFixing,
    Scrolling,
    StateStoring,
} from "devextreme-react/data-grid";
let detailInDataGrid = React.createRef();
let accessToken = '';
const gridKey = "b1fde378-f038-46ce-896e-47deb5a6548b";
const statusLookup = [
    { ID: 'O', Text: "Open" },
    { ID: 'H', Text: "Hold" },
    { ID: 'L', Text: "Ready To Commit Later" },
    { ID: 'N', Text: "Ready To Commit Now" },
];
const toStage = [
    { ID: 'L', Text: 'Canceled - No Inventory Effect' },
    { ID: 'Q', Text: 'Quote - No Inventory Effect' },
    { ID: 'P', Text: 'Plan - No Inventory Effect' },
    { ID: 'F', Text: 'Future - No Effect on Net Available' },
    { ID: 'N', Text: 'Pending - Effects Net Available' },
    { ID: 'A', Text: 'Assigned - Effects Available' },
    { ID: 'S', Text: 'Picked/Staged - Effects Available' },
    { ID: 'C', Text: 'Shipped/Completed - Effects Available' }
];
class ExportEdiDocumentsPreview extends React.Component {

    constructor(props) {
        super(props);
        accessToken = props.oidc.user.access_token;

        this.state = {
            records: 0
        }
        this.loadState = this.loadState.bind(this);
        this.saveState = this.saveState.bind(this);
    }

    loadState() {
        // const { gridKey, accessToken } = this.state;
        return GridLayout.sendStorageRequest(gridKey, "GET", accessToken);
    }

    saveState(state) {
        GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state);
    }
    render() {
        return (
            <div className="row" style={{ height: '100%', width: '100%' }}>
                <DataGrid

                    onExporting={(e) => {
                        if (window.handleDevExtremeDataGridExport) {
                            window.handleDevExtremeDataGridExport(e);
                        }
                    }}
                    dataSource={this.props.dataSource}
                    showBorders={true}
                    ref={detailInDataGrid}
                    className="customDataTableDesignCommit"
                    hoverStateEnabled={true}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                    columnAutoWidth={true}
                    showRowLines={true}
                    style={{ height: '100%', width: '100%' }}
                //onContentReady={this.DetailInGridContentReady}
                >
                    <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={290}
                        sortOrder="asc"
                    >
                        <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <ColumnFixing enabled={true} />
                    <ColumnHeaderFilter />
                    <Export enabled={true} allowExportSelectedData={true} text="Export" />
                    <Sorting visible={true} mode="multiple" />
                    <LoadPanel enabled={true} />
                    <Paging defaultPageSize={10} />
                    <Pager
                        visible={true}
                        showPageSizeSelector={true}
                        allowedPageSizes={[10, 20, 50, 500, 1000, "all"]}
                        showNavigationButtons={true}
                    />
                    <FilterRow visible={true} />
                    <FilterPanel visible={true} />
                    <HeaderFilter />
                    <GroupPanel visible={true} />
                    <Grouping autoExpandAll={false} />
                    <StateStoring
                        enabled={true}
                        type="custom"
                        customLoad={this.loadState}
                        storageKey={gridKey}
                        customSave={this.saveState}
                    />
                    <Column
                        dataField="TransactionNumber"
                        caption="Transaction #"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="TransactionDueDate"
                        caption="Due Date"
                        dataType="datetime"
                        format="MM/dd/yyyy"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="PickStatus"
                        caption="Pick Status"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="Stage"
                        caption="Stage"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="Reference"
                        caption="PO Number"
                        allowEditing={false}
                    ></Column>




                    <Column
                        dataField="CustomerId"
                        caption="Customer ID"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="CustomerName"
                        caption="Customer Name"
                        allowEditing={false}
                    ></Column>


                    <Column
                        dataField="Status"
                        caption="Status"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="TransactionType"
                        caption="Transaction Type"
                        allowEditing={false}
                    ></Column>

                    <Column
                        dataField="InvoiceDate"
                        caption="Invoice Date"
                        dataType="datetime"
                        format="MM/dd/yyyy"
                        allowEditing={false}
                    ></Column>

                    <Column
                        dataField="PurchaseOrderNumber"
                        caption="Purchase Order #"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="PriceLevel"
                        caption="Price Level"
                        allowEditing={false}
                    ></Column>

                    <Column
                        dataField="DiscountType"
                        caption="Discount Type"
                        allowEditing={false}
                    ></Column>

                    <Column
                        dataField="ShippingDate"
                        caption="Shipping Date"
                        dataType="datetime"
                        format="MM/dd/yyyy"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="TruckReference"
                        caption="Truck Reference"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedCode1"
                        caption="Code 1"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedCode2"
                        caption="Code 2"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedCode3"
                        caption="Code 3"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedCode4"
                        caption="Code 4"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedCode5"
                        caption="Code 5"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedCode6"
                        caption="Code 6"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedCode7"
                        caption="Code 7"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedCode8"
                        caption="Code 8"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedCode9"
                        caption="Code 9"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedCode10"
                        caption="Code 10"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedDate1"
                        caption="Date 1"
                        dataType="datetime"
                        format="MM/dd/yyyy"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedDate2"
                        caption="Date 2"
                        dataType="datetime"
                        format="MM/dd/yyyy"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedDate3"
                        caption="Date 3"
                        dataType="datetime"
                        format="MM/dd/yyyy"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedDate4"
                        caption="Date 4"
                        dataType="datetime"
                        format="MM/dd/yyyy"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedDate5"
                        caption="Date 5"
                        dataType="datetime"
                        format="MM/dd/yyyy"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedDate6"
                        caption="Date 6"
                        dataType="datetime"
                        format="MM/dd/yyyy"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedDate7"
                        caption="Date 7"
                        dataType="datetime"
                        format="MM/dd/yyyy"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedDate8"
                        caption="Date 8"
                        dataType="datetime"
                        format="MM/dd/yyyy"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedDate9"
                        caption="Date 9"
                        dataType="datetime"
                        format="MM/dd/yyyy"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedDate10"
                        caption="Date 10"
                        dataType="datetime"
                        format="MM/dd/yyyy"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedQuantity1"
                        caption="Quantity 1"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedQuantity2"
                        caption="Quantity 2"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedQuantity3"
                        caption="Quantity 3"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedQuantity4"
                        caption="Quantity 4"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedQuantity5"
                        caption="Quantity 5"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedQuantity6"
                        caption="Quantity 6"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedQuantity7"
                        caption="Quantity 7"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedQuantity8"
                        caption="Quantity 8"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedQuantity9"
                        caption="Quantity 9"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedQuantity10"
                        caption="Quantity 10"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedReference1"
                        caption="Reference 1"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedReference2"
                        caption="Reference 2"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedReference3"
                        caption="Reference 3"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedReference4"
                        caption="Reference 4"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedReference5"
                        caption="Reference 5"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedReference6"
                        caption="Reference 6"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedReference7"
                        caption="Reference 7"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedReference8"
                        caption="Reference 8"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedReference9"
                        caption="Reference 9"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="UserDefinedReference10"
                        caption="Reference 10"
                        allowEditing={false}
                        visible={false}
                    ></Column>
                    <Column
                        dataField="DiscountPercent"
                        caption="Discount Percent"
                        dataType="number"
                        format="#,##0.00"
                        allowEditing={false}
                    ></Column>

                    <Column
                        dataField="FMTripNumber"
                        caption="FM Trip Number"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="FMPUStopNumber"
                        caption="FM PU Stop Number"
                        dataType="number"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="BackOrderFlag"
                        caption="Back Order Flag"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="EDITransmitFlag"
                        caption="EDI Transmit Flag"
                        allowEditing={false}
                    ></Column>

                    <Column
                        dataField="ShipToId"
                        caption="Ship To ID"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="ShipToName"
                        caption="Ship To Name"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="RTradingPartner"
                        caption="R Trading Partner"
                        allowEditing={false}
                        visible={false}
                    ></Column>

                </DataGrid>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(ExportEdiDocumentsPreview);